import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';
import type { ResultOf } from 'gql.tada';

const EnrollmentInvitePreviewQuery = graphql.persisted(
  "EnrollmentInvitePreview",
  graphql(`
    query EnrollmentInvitePreview($schoolId: ID!, $familyEnrollmentIds: [ID!]!) {
      enrollmentInvitePreview(schoolId: $schoolId, familyEnrollmentIds: $familyEnrollmentIds) {
        familyEnrollmentId
        familyName
        canInvite
        willResend
        reason
        warnings
        guardians { name email outcome }
      }
    }
  `)
);

export type EnrollmentInvitePreviewRow = ResultOf<typeof EnrollmentInvitePreviewQuery>['enrollmentInvitePreview'][number];

export { EnrollmentInvitePreviewQuery };

export function useEnrollmentInvitePreview(schoolId?: string, familyEnrollmentIds: string[] = []) {
  return useQuery(EnrollmentInvitePreviewQuery, {
    variables: { schoolId: schoolId!, familyEnrollmentIds },
    skip: !schoolId || familyEnrollmentIds.length === 0,
    fetchPolicy: 'network-only',
  });
}
